import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'oaibox-mimo-create-configuration',
    templateUrl: './mimo-create-configuration.component.html',
    styleUrls: ['./mimo-create-configuration.component.css'],
    imports: [ReactiveFormsModule]
})
export class MimoUSRPCreateConfigurationComponent {

  @Input() public editableMimoOptions?: string[];
  @Input() public defaultMimoOptions?: string[];
  @Output() public optionsChange: EventEmitter<string[]> = new EventEmitter();

  public mimoOptionsForm: FormGroup;

  constructor() {
    this.mimoOptionsForm = new FormGroup({
      mimo: new FormControl(undefined, Validators.required),
    });
  }

  public addMimoOption(): void {
    const mimo: string = this.mimoOptionsForm.value.mimo;
    if (mimo) {
      if(!this.editableMimoOptions) this.editableMimoOptions = [];
      this.editableMimoOptions.push(mimo.toUpperCase());
      this.optionsChange.emit(this.editableMimoOptions);
    }

    this.mimoOptionsForm.reset();
  }

  public removeMimoOption(index: number): void {
    this.editableMimoOptions?.splice(index, 1);
    this.optionsChange.emit(this.editableMimoOptions);
  }
}
